import { render, staticRenderFns } from "./ProdutosdoPedido.vue?vue&type=template&id=99dc5830&scoped=true&"
import script from "./ProdutosdoPedido.vue?vue&type=script&lang=js&"
export * from "./ProdutosdoPedido.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosdoPedido.vue?vue&type=style&index=0&id=99dc5830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dc5830",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
